import React, {useEffect} from "react";
import {ImagesLBanAds} from "../../../constant/DumpAds"

const LeftAds = () => {

    useEffect(() => {
        const data = ImagesLBanAds;
        let l = data.length;
        let randomAds = Math.floor(l*Math.random())
        document.getElementById("leftBanAds").src = data[randomAds]

    }, []);

    return (
        <div style={{ height: "auto" }}>
            <img id="leftBanAds" src="" alt="left-ban-ads" />
            <div className="clear" />
        </div>
    );
};

export default LeftAds;
